<template>
  <div class="relative">
    <slot></slot>
    <UBadge
      class="pointer-events-none absolute top-0 right-0 !bg-cardinal !text-white !text-xs !px-1 !py-0.5"
      >New</UBadge
    >
  </div>
</template>
